import {LOGGED_USER_PAWLINK, UNLOGGED_USER_PAWLINK, CSS_PAW_SELECTOR} from '../constants';

let loggedUser = null;

const changeLink = element => {
  if (element && element.href) {
    element.href = loggedUser ? LOGGED_USER_PAWLINK : UNLOGGED_USER_PAWLINK;
  }
};

const nodeHandler = node => {
  if (node.nodeName.toLowerCase() === 'div' && node.className.indexOf('sssp-posCont') !== -1) {
    changeLink(node.querySelector(CSS_PAW_SELECTOR), loggedUser);
  }
};

const mutHandler = mutation => {
  if (mutation.type === 'childList') {
    Array.from(mutation.addedNodes).forEach(node => nodeHandler(node));
  }
};

const mutListCallback = mutationsList => {
  Array.from(mutationsList).forEach(mutation => mutHandler(mutation));
};

const watchChangesInDOM = () => {
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(mutListCallback);

    observer.observe(document.body, {attributes: false, childList: true, subtree: true});
  }
};

export default function setPaws(_loggedUser) {
  if (!document.body) {
    return;
  }
  loggedUser = _loggedUser;

  const paws = document.querySelectorAll(CSS_PAW_SELECTOR);
  if (paws) {
    Array.from(paws).forEach(link => changeLink(link));
  }

  watchChangesInDOM();
}
